import { Injectable } from '@angular/core';
import { DataService } from 'app/shared/services/data.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { Observable } from 'rxjs';
import { IResult } from 'app/shared/models/result.model';
import { map } from 'rxjs/operators';
import { IDtoSystem } from 'app/shared/models/security/dto-system.model';
import { IDtoRole } from 'app/shared/models/security/dto-role.model';
import { ISelect } from 'app/shared/models/select.model';
import { IDtoModule } from 'app/shared/models/security/dto-module.model';
import { IDtoUserRole } from 'app/shared/models/security/dto-user-role.model';
import { SecurityService } from 'app/shared/services/security.service';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { AppConfig } from 'app/app.config';
import { IDtoUser } from 'app/shared/models/security/dto-user.model';
@Injectable({
    providedIn: 'root'
})
export class IdentityService {
    private roles: any;
    public userData: any;
    private identityUrl = '';
    constructor(private service: DataService
        , private configurationService: ConfigurationService
        , private securityService: SecurityService
        , private configGeneral: AppConfig) {
        if (this.configurationService.isReady) {
            this.identityUrl = this.configurationService.serverSettings.identityUrl;
        } else {
            this.configurationService.settingsLoaded$.subscribe(x =>
                this.identityUrl = this.configurationService.serverSettings.identityUrl);
        }
    }

    loadUserData(): Promise<void> {
        return new Promise((resolve, reject) => {
            const showRoles = this.securityService.getUserRolesStorage();
            if (showRoles) {
                this.roles = showRoles.listRoles;
            }
            this.userData = this.securityService.getUserDataStorage();
            resolve();
        });
    }

    public getUsers(): Observable<IResult> {
        const url = `${this.identityUrl}api/users/getUsers/`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public addUser(data: any): Observable<IResult> {
        const url = `${this.identityUrl}api/users/addUser/`;

        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public updateUser(data: any): Observable<IResult> {
        const url = `${this.identityUrl}api/users/putUser/`;

        return this.service.putWithId(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public changePassword(data: any): Observable<IResult> {
        const url = `${this.identityUrl}api/users/changePassword/`;

        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public restorePassword(data: IDtoUser): Observable<IResult> {
        const url = `${this.identityUrl}api/users/restorePassword/`;

        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public accountActivation(data: IDtoUser): Observable<IResult> {
        const url = `${this.identityUrl}api/users/accountActivation/`;

        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public deleteUser(id: string): Observable<IResult> {
        const url = `${this.identityUrl}api/users/deleteUser?id=${id}`;

        return this.service.delete(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public addSystem(data: IDtoSystem): Observable<IResult> {
        const url = `${this.identityUrl}api/systems/addSystem/`;

        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public getSystems(): Observable<IResult> {
        const url = `${this.identityUrl}api/systems/getSystems/`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public addRole(data: IDtoRole): Observable<IResult> {
        const url = `${this.identityUrl}api/roles/addRole/`;

        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public getRoles(): Observable<IResult> {
        const url = `${this.identityUrl}api/roles/getRoles/`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogRoles(): Observable<ISelect[]> {
        const url = `${this.identityUrl}api/roles/getCatalogRoles/`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public deleteRole(data: IDtoRole): Observable<IResult> {
        const url = `${this.identityUrl}api/roles/deleteRole?name=${data.name}`;

        return this.service.delete(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public addModule(data: IDtoModule): Observable<IResult> {
        const url = `${this.identityUrl}api/modules/addModule/`;

        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public updateModule(data: IDtoModule): Observable<IResult> {
        const url = `${this.identityUrl}api/modules/putModule/`;

        return this.service.putWithId(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public getModulesBySystem(systemId: number): Observable<IResult> {
        const url = `${this.identityUrl}api/modules/getModulebySystemId?systemId=${systemId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogSystems(): Observable<ISelect[]> {
        const url = `${this.identityUrl}api/systems/getCatalogSystems/`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogModulesBySystem(systemId: number): Observable<ISelect[]> {
        const url = `${this.identityUrl}api/modules/getCatalogModules?systemId=${systemId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogRoleByModule(moduleId: string): Observable<ISelect[]> {
        const url = `${this.identityUrl}api/roles/getCatalogRolebyModule?moduleId=${moduleId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getRolesByUser(userId: string): Observable<IResult> {
        const url = `${this.identityUrl}api/UsersRoles/getUserRolebyUserId?userId=${userId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public addUserRole(data: IDtoUserRole): Observable<IResult> {
        const url = `${this.identityUrl}api/usersRoles/addUserRol/`;

        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public deleteUserRole(data: IDtoUserRole): Observable<IResult> {
        const url = `${this.identityUrl}api/usersRoles/deleteUserRol/`;

        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    /**Accesos */
    public RolesAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'Roles')[0];
            return acceso === undefined ? false : true;
        }
    }
    public RequestAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'Request')[0];
            return acceso === undefined ? false : true;
        }
    }
    public RequestReviewsAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'RequestReviews')[0];
            return acceso === undefined ? false : true;
        }
    }
    public UsersAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'Users')[0];
            return acceso === undefined ? false : true;
        }
    }
    public RequisitionReviewsAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'RequisitionReviews')[0];
            return acceso === undefined ? false : true;
        }
    }
    public SystemsAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'Systems')[0];
            return acceso === undefined ? false : true;
        }
    }
    public RequisitionDetailAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'RequisitionDetail')[0];
            return acceso === undefined ? false : true;
        }
    }
    public HolidayRequestAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'HolidayRequest')[0];
            return acceso === undefined ? false : true;
        }
    }
    public HolidayApprovalAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'HolidayApproval')[0];
            return acceso === undefined ? false : true;
        }
    }
    public InabilityAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'Inability')[0];
            return acceso === undefined ? false : true;
        }
    }
    public InabilityRecordsAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'InabilityRecords')[0];
            return acceso === undefined ? false : true;
        }
    }
    public WorkLeaveAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'WorkLeave')[0];
            return acceso === undefined ? false : true;
        }
    }
    public WorkLeaveRecordsAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'WorkLeaveRecords')[0];
            return acceso === undefined ? false : true;
        }
    }
    public CompaniesAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'Companies')[0];
            return acceso === undefined ? false : true;
        }
    }
    public CustomersAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'Customers')[0];
            return acceso === undefined ? false : true;
        }
    }
    public ProjectsAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'Projects')[0];
            return acceso === undefined ? false : true;
        }
    }
    public ProductsAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'Products')[0];
            return acceso === undefined ? false : true;
        }
    }
    public WorkingDaysAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'WorkingDays')[0];
            return acceso === undefined ? false : true;
        }
    }
    public JobRecordsAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'Jobs')[0];
            return acceso === undefined ? false : true;
        }
    }
    public JobAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'JobCreation')[0];
            return acceso === undefined ? false : true;
        }
    }
    public BudgetRecordsAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'Budgets')[0];
            return acceso === undefined ? false : true;
        }
    }
    public BudgetAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'BudgetCreation')[0];
            return acceso === undefined ? false : true;
        }
    }
    public NotesAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'Notes')[0];
            return acceso === undefined ? false : true;
        }
    }
    public CustomerCommissionsAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'CustomerCommissions')[0];
            return acceso === undefined ? false : true;
        }
    }
    public RelocationAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'Relocation')[0];
            return acceso === undefined ? false : true;
        }
    }
    public RelocationRecordsAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'RelocationRecords')[0];
            return acceso === undefined ? false : true;
        }
    }
    public RetroactiveAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'Retroactives')[0];
            return acceso === undefined ? false : true;
        }
    }
    public PayrollAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.securityService.getUserRolesStorage().listRoles.filter((item) => item.nameModule === 'Payroll')[0];
            return acceso === undefined ? false : true;
        }
    }
    public PayrollRecordsAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'PayrollRecords')[0];
            return acceso === undefined ? false : true;
        }
    }
    public CommissionRecordsAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'CommissionRecords')[0];
            return acceso === undefined ? false : true;
        }
    }
    public CommissionAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'Commission')[0];
            return acceso === undefined ? false : true;
        }
    }
    public EmployeesAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'Employees')[0];
            return acceso === undefined ? false : true;
        }
    }
    public LiquidationAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'Liquidation')[0];
            return acceso === undefined ? false : true;
        }
    }
    public LiquidationRecordsAccess(): boolean {
        if (this.roles !== undefined) {
            const acceso = this.roles.filter((item) => item.nameModule === 'LiquidationRecords')[0];
            return acceso === undefined ? false : true;
        }
    }
    /** */
    public getRouteByUrl(base: string): Observable<IResult> {
        const url = `${this.identityUrl}api/Routes/getRouteByUrl?url=${base}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getUserRequestCapture(): Observable<IResult> {
        const url = `${this.identityUrl}api/Tokens/getUserRequestCapture`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public addModuleLog(dto: IDtoModuleLog): Observable<IResult> {
        const url = `${this.identityUrl}api/ModuleLogs/addModuleLog/`;
        dto.userId = this.roles[0].userId;
        dto.employeeId = this.roles[0].employeeId;
        dto.role = this.securityService.getProfileStorage(dto.module);
        dto.creationDate = this.configGeneral.getLocalISOTime(new Date());
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public addModuleLogComplete(dto: IDtoModuleLog): Observable<IResult> {
        const url = `${this.identityUrl}api/ModuleLogs/addModuleLog/`;
        dto.creationDate = this.configGeneral.getLocalISOTime(new Date());
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    private employeeModuleProfiles: IDtoEmployeeModuleProfile[] = [
        {
            profile: 'Administrador', activateSaveFormGeneralData: true, activateSaveFormPersonalData: true, activateSaveFormPaymentData: true, activateSaveFormBasicData: true, activateSaveFormStudy: true, activateSaveFormDocument: true, actions: [
                { control: 'firstName', read: true, write: true }
                , { control: 'lastName', read: true, write: true }
                , { control: 'secondLastName', read: true, write: true }
                , { control: 'birthDate', read: true, write: true }
                , { control: 'stateBirthId', read: true, write: true }
                , { control: 'gender', read: true, write: true }
                , { control: 'curp', read: true, write: true }
                , { control: 'rfc', read: true, write: true }
                , { control: 'imss', read: true, write: true }
                , { control: 'email', read: true, write: true }
                , { control: 'bossId', read: true, write: true }
                , { control: 'supervisorId', read: true, write: true }
                , { control: 'payrollOfficerId', read: true, write: true }
                , { control: 'workingDayId', read: true, write: true }
                , { control: 'maritalStatusId', read: true, write: true }
                , { control: 'personalNumber', read: true, write: true }
                , { control: 'street', read: true, write: true }
                , { control: 'interiorNumber', read: true, write: true }
                , { control: 'externalNumber', read: true, write: true }
                , { control: 'postalCode', read: true, write: true }
                , { control: 'suburb', read: true, write: true }
                , { control: 'stateId', read: true, write: true }
                , { control: 'townId', read: true, write: true }
                , { control: 'patrimonialRegimeId', read: true, write: true }
                , { control: 'dailySalary', read: true, write: false }
                , { control: 'integratedDailySalary', read: true, write: false }
                , { control: 'bankId', read: true, write: true }
                , { control: 'bankAccount', read: true, write: true }
                , { control: 'methodPaymentId', read: true, write: true }
                , { control: 'classification', read: true, write: true }
                , { control: 'typeSalaryId', read: true, write: true }
                , { control: 'pantryAccount', read: true, write: true }
                , { control: 'pantryCard', read: true, write: true }
                , { control: 'gasolineCard', read: true, write: true }
                , { control: 'gasolineIdentifier', read: true, write: true }
                , { control: 'interbankClabe', read: true, write: true }
                , { control: 'subsidy', read: true, write: true }
                , { control: 'requisitionContractTypeId', read: true, write: true }
                , { control: 'laborSeniorityDate', read: true, write: false }
                , { control: 'employerRegisterId', read: true, write: true }
                , { control: 'salaryZoneId', read: true, write: true }
                , { control: 'familyMedicalUnitId', read: true, write: true }
                , { control: 'unionized', read: true, write: true }
                , { control: 'accountingSegmentId', read: true, write: true }
                , { control: 'individualAccount', read: true, write: true }
                , { control: 'pieceWorker', read: true, write: true }
                , { control: 'benefitCategoryId', read: true, write: true }
                , { control: 'alimony', read: true, write: true }
                , { control: 'hasInfonavit', read: true, write: true }
                , { control: 'schoolLevelId', read: true, write: true }
                , { control: 'educationLevelId', read: true, write: true }
                , { control: 'institute', read: true, write: true }
                , { control: 'documentReceivedId', read: true, write: true }
                , { control: 'studyPeriod', read: true, write: true }
                , { control: 'document', read: true, write: true }]
        },
        {
            profile: 'Nomina', activateSaveFormGeneralData: false, activateSaveFormPersonalData: false, activateSaveFormPaymentData: true, activateSaveFormBasicData: true, activateSaveFormStudy: false, activateSaveFormDocument: true, actions: [
                { control: 'firstName', read: true, write: false }
                , { control: 'lastName', read: true, write: false }
                , { control: 'secondLastName', read: true, write: false }
                , { control: 'birthDate', read: true, write: false }
                , { control: 'stateBirthId', read: true, write: false }
                , { control: 'gender', read: true, write: false }
                , { control: 'curp', read: true, write: false }
                , { control: 'rfc', read: true, write: false }
                , { control: 'imss', read: true, write: false }
                , { control: 'email', read: true, write: false }
                , { control: 'bossId', read: true, write: false }
                , { control: 'supervisorId', read: true, write: false }
                , { control: 'payrollOfficerId', read: true, write: false }
                , { control: 'workingDayId', read: true, write: false }
                , { control: 'maritalStatusId', read: true, write: false }
                , { control: 'personalNumber', read: true, write: false }
                , { control: 'street', read: true, write: false }
                , { control: 'interiorNumber', read: true, write: false }
                , { control: 'externalNumber', read: true, write: false }
                , { control: 'postalCode', read: true, write: false }
                , { control: 'suburb', read: true, write: false }
                , { control: 'stateId', read: true, write: false }
                , { control: 'townId', read: true, write: false }
                , { control: 'patrimonialRegimeId', read: true, write: false }
                , { control: 'dailySalary', read: true, write: false }
                , { control: 'integratedDailySalary', read: true, write: false }
                , { control: 'bankId', read: true, write: true }
                , { control: 'bankAccount', read: true, write: true }
                , { control: 'methodPaymentId', read: true, write: true }
                , { control: 'classification', read: true, write: false }
                , { control: 'typeSalaryId', read: true, write: false }
                , { control: 'pantryAccount', read: true, write: true }
                , { control: 'pantryCard', read: true, write: true }
                , { control: 'gasolineCard', read: true, write: true }
                , { control: 'gasolineIdentifier', read: true, write: true }
                , { control: 'interbankClabe', read: true, write: true }
                , { control: 'subsidy', read: true, write: true }
                , { control: 'requisitionContractTypeId', read: true, write: false }
                , { control: 'laborSeniorityDate', read: true, write: false }
                , { control: 'employerRegisterId', read: true, write: false }
                , { control: 'salaryZoneId', read: true, write: true }
                , { control: 'familyMedicalUnitId', read: true, write: true }
                , { control: 'unionized', read: true, write: true }
                , { control: 'accountingSegmentId', read: true, write: true }
                , { control: 'individualAccount', read: true, write: true }
                , { control: 'pieceWorker', read: true, write: true }
                , { control: 'benefitCategoryId', read: true, write: true }
                , { control: 'alimony', read: true, write: false }
                , { control: 'hasInfonavit', read: true, write: false }
                , { control: 'schoolLevelId', read: true, write: false }
                , { control: 'educationLevelId', read: true, write: false }
                , { control: 'institute', read: true, write: false }
                , { control: 'documentReceivedId', read: true, write: false }
                , { control: 'studyPeriod', read: true, write: false }
                , { control: 'document', read: true, write: true }]
        },
        {
            profile: 'Coordinador', activateSaveFormGeneralData: true, activateSaveFormPersonalData: true, activateSaveFormPaymentData: false, activateSaveFormBasicData: true, activateSaveFormStudy: true, activateSaveFormDocument: true, actions: [
                { control: 'firstName', read: true, write: false }
                , { control: 'lastName', read: true, write: false }
                , { control: 'secondLastName', read: true, write: false }
                , { control: 'birthDate', read: true, write: false }
                , { control: 'stateBirthId', read: true, write: false }
                , { control: 'gender', read: true, write: false }
                , { control: 'curp', read: true, write: false }
                , { control: 'rfc', read: true, write: false }
                , { control: 'imss', read: true, write: false }
                , { control: 'email', read: true, write: true }
                , { control: 'bossId', read: true, write: true }
                , { control: 'supervisorId', read: true, write: true }
                , { control: 'payrollOfficerId', read: true, write: true }
                , { control: 'workingDayId', read: true, write: true }
                , { control: 'maritalStatusId', read: true, write: true }
                , { control: 'personalNumber', read: true, write: true }
                , { control: 'street', read: true, write: true }
                , { control: 'interiorNumber', read: true, write: true }
                , { control: 'externalNumber', read: true, write: true }
                , { control: 'postalCode', read: true, write: true }
                , { control: 'suburb', read: true, write: true }
                , { control: 'stateId', read: true, write: true }
                , { control: 'townId', read: true, write: true }
                , { control: 'patrimonialRegimeId', read: true, write: true }
                , { control: 'dailySalary', read: true, write: false }
                , { control: 'integratedDailySalary', read: true, write: false }
                , { control: 'bankId', read: true, write: false }
                , { control: 'bankAccount', read: true, write: false }
                , { control: 'methodPaymentId', read: true, write: false }
                , { control: 'classification', read: true, write: false }
                , { control: 'typeSalaryId', read: true, write: false }
                , { control: 'pantryAccount', read: true, write: false }
                , { control: 'pantryCard', read: true, write: false }
                , { control: 'gasolineCard', read: true, write: false }
                , { control: 'gasolineIdentifier', read: true, write: false }
                , { control: 'interbankClabe', read: true, write: false }
                , { control: 'subsidy', read: true, write: false }
                , { control: 'requisitionContractTypeId', read: true, write: true }
                , { control: 'laborSeniorityDate', read: true, write: false }
                , { control: 'employerRegisterId', read: true, write: false }
                , { control: 'salaryZoneId', read: true, write: false }
                , { control: 'familyMedicalUnitId', read: true, write: false }
                , { control: 'unionized', read: true, write: false }
                , { control: 'accountingSegmentId', read: true, write: false }
                , { control: 'individualAccount', read: true, write: false }
                , { control: 'pieceWorker', read: true, write: false }
                , { control: 'benefitCategoryId', read: true, write: false }
                , { control: 'alimony', read: true, write: false }
                , { control: 'hasInfonavit', read: true, write: false }
                , { control: 'schoolLevelId', read: true, write: true }
                , { control: 'educationLevelId', read: true, write: true }
                , { control: 'institute', read: true, write: true }
                , { control: 'documentReceivedId', read: true, write: true }
                , { control: 'studyPeriod', read: true, write: true }
                , { control: 'document', read: true, write: true }]
        },
        {
            profile: 'Ejecutivo', activateSaveFormGeneralData: true, activateSaveFormPersonalData: true, activateSaveFormPaymentData: false, activateSaveFormBasicData: true, activateSaveFormStudy: true, activateSaveFormDocument: true, actions: [
                { control: 'firstName', read: true, write: false }
                , { control: 'lastName', read: true, write: false }
                , { control: 'secondLastName', read: true, write: false }
                , { control: 'birthDate', read: true, write: false }
                , { control: 'stateBirthId', read: true, write: false }
                , { control: 'gender', read: true, write: false }
                , { control: 'curp', read: true, write: false }
                , { control: 'rfc', read: true, write: false }
                , { control: 'imss', read: true, write: false }
                , { control: 'email', read: true, write: true }
                , { control: 'bossId', read: true, write: true }
                , { control: 'supervisorId', read: true, write: true }
                , { control: 'payrollOfficerId', read: true, write: true }
                , { control: 'workingDayId', read: true, write: true }
                , { control: 'maritalStatusId', read: true, write: true }
                , { control: 'personalNumber', read: true, write: true }
                , { control: 'street', read: true, write: true }
                , { control: 'interiorNumber', read: true, write: true }
                , { control: 'externalNumber', read: true, write: true }
                , { control: 'postalCode', read: true, write: true }
                , { control: 'suburb', read: true, write: true }
                , { control: 'stateId', read: true, write: true }
                , { control: 'townId', read: true, write: true }
                , { control: 'patrimonialRegimeId', read: true, write: true }
                , { control: 'dailySalary', read: true, write: false }
                , { control: 'integratedDailySalary', read: true, write: false }
                , { control: 'bankId', read: true, write: false }
                , { control: 'bankAccount', read: true, write: false }
                , { control: 'methodPaymentId', read: true, write: false }
                , { control: 'classification', read: true, write: false }
                , { control: 'typeSalaryId', read: true, write: false }
                , { control: 'pantryAccount', read: true, write: false }
                , { control: 'pantryCard', read: true, write: false }
                , { control: 'gasolineCard', read: true, write: false }
                , { control: 'gasolineIdentifier', read: true, write: false }
                , { control: 'interbankClabe', read: true, write: false }
                , { control: 'subsidy', read: true, write: false }
                , { control: 'requisitionContractTypeId', read: true, write: true }
                , { control: 'laborSeniorityDate', read: true, write: false }
                , { control: 'employerRegisterId', read: true, write: false }
                , { control: 'salaryZoneId', read: true, write: false }
                , { control: 'familyMedicalUnitId', read: true, write: false }
                , { control: 'unionized', read: true, write: false }
                , { control: 'accountingSegmentId', read: true, write: false }
                , { control: 'individualAccount', read: true, write: false }
                , { control: 'pieceWorker', read: true, write: false }
                , { control: 'benefitCategoryId', read: true, write: false }
                , { control: 'alimony', read: true, write: false }
                , { control: 'hasInfonavit', read: true, write: false }
                , { control: 'schoolLevelId', read: true, write: true }
                , { control: 'educationLevelId', read: true, write: true }
                , { control: 'institute', read: true, write: true }
                , { control: 'documentReceivedId', read: true, write: true }
                , { control: 'studyPeriod', read: true, write: true }
                , { control: 'document', read: true, write: true }]
        },
        {
            profile: 'Reclutamiento', activateSaveFormGeneralData: true, activateSaveFormPersonalData: true, activateSaveFormPaymentData: false, activateSaveFormBasicData: false, activateSaveFormStudy: true, activateSaveFormDocument: true, actions: [
                { control: 'firstName', read: true, write: true }
                , { control: 'lastName', read: true, write: true }
                , { control: 'secondLastName', read: true, write: true }
                , { control: 'birthDate', read: true, write: true }
                , { control: 'stateBirthId', read: true, write: true }
                , { control: 'gender', read: true, write: true }
                , { control: 'curp', read: true, write: true }
                , { control: 'rfc', read: true, write: true }
                , { control: 'imss', read: true, write: true }
                , { control: 'email', read: true, write: false }
                , { control: 'bossId', read: true, write: false }
                , { control: 'supervisorId', read: true, write: false }
                , { control: 'payrollOfficerId', read: true, write: false }
                , { control: 'workingDayId', read: true, write: false }
                , { control: 'maritalStatusId', read: true, write: true }
                , { control: 'personalNumber', read: true, write: true }
                , { control: 'street', read: true, write: true }
                , { control: 'interiorNumber', read: true, write: true }
                , { control: 'externalNumber', read: true, write: true }
                , { control: 'postalCode', read: true, write: true }
                , { control: 'suburb', read: true, write: true }
                , { control: 'stateId', read: true, write: true }
                , { control: 'townId', read: true, write: true }
                , { control: 'patrimonialRegimeId', read: true, write: true }
                , { control: 'dailySalary', read: false, write: false }
                , { control: 'integratedDailySalary', read: false, write: false }
                , { control: 'bankId', read: true, write: false }
                , { control: 'bankAccount', read: true, write: false }
                , { control: 'methodPaymentId', read: true, write: false }
                , { control: 'classification', read: false, write: false }
                , { control: 'typeSalaryId', read: false, write: false }
                , { control: 'pantryAccount', read: false, write: false }
                , { control: 'pantryCard', read: false, write: false }
                , { control: 'gasolineCard', read: false, write: false }
                , { control: 'gasolineIdentifier', read: false, write: false }
                , { control: 'interbankClabe', read: true, write: false }
                , { control: 'subsidy', read: false, write: false }
                , { control: 'requisitionContractTypeId', read: false, write: false }
                , { control: 'laborSeniorityDate', read: false, write: false }
                , { control: 'employerRegisterId', read: true, write: false }
                , { control: 'salaryZoneId', read: false, write: false }
                , { control: 'familyMedicalUnitId', read: false, write: false }
                , { control: 'unionized', read: false, write: false }
                , { control: 'accountingSegmentId', read: false, write: false }
                , { control: 'individualAccount', read: false, write: false }
                , { control: 'pieceWorker', read: false, write: false }
                , { control: 'benefitCategoryId', read: false, write: false }
                , { control: 'alimony', read: true, write: false }
                , { control: 'hasInfonavit', read: true, write: false }
                , { control: 'schoolLevelId', read: true, write: true }
                , { control: 'educationLevelId', read: true, write: true }
                , { control: 'institute', read: true, write: true }
                , { control: 'documentReceivedId', read: true, write: true }
                , { control: 'studyPeriod', read: true, write: true }
                , { control: 'document', read: true, write: true }]
        },
        {
            profile: 'IMSS', activateSaveFormGeneralData: false, activateSaveFormPersonalData: false, activateSaveFormPaymentData: true, activateSaveFormBasicData: true, activateSaveFormStudy: false, activateSaveFormDocument: true, actions: [
                { control: 'firstName', read: true, write: false }
                , { control: 'lastName', read: true, write: false }
                , { control: 'secondLastName', read: true, write: false }
                , { control: 'birthDate', read: true, write: false }
                , { control: 'stateBirthId', read: true, write: false }
                , { control: 'gender', read: true, write: false }
                , { control: 'curp', read: true, write: false }
                , { control: 'rfc', read: true, write: false }
                , { control: 'imss', read: true, write: false }
                , { control: 'email', read: true, write: false }
                , { control: 'bossId', read: true, write: false }
                , { control: 'supervisorId', read: true, write: false }
                , { control: 'payrollOfficerId', read: true, write: false }
                , { control: 'workingDayId', read: true, write: false }
                , { control: 'maritalStatusId', read: true, write: false }
                , { control: 'personalNumber', read: true, write: false }
                , { control: 'street', read: true, write: false }
                , { control: 'interiorNumber', read: true, write: false }
                , { control: 'externalNumber', read: true, write: false }
                , { control: 'postalCode', read: true, write: false }
                , { control: 'suburb', read: true, write: false }
                , { control: 'stateId', read: true, write: false }
                , { control: 'townId', read: true, write: false }
                , { control: 'patrimonialRegimeId', read: true, write: false }
                , { control: 'dailySalary', read: true, write: false }
                , { control: 'integratedDailySalary', read: true, write: false }
                , { control: 'bankId', read: false, write: false }
                , { control: 'bankAccount', read: false, write: false }
                , { control: 'methodPaymentId', read: false, write: false }
                , { control: 'classification', read: false, write: false }
                , { control: 'typeSalaryId', read: true, write: true }
                , { control: 'pantryAccount', read: false, write: false }
                , { control: 'pantryCard', read: false, write: false }
                , { control: 'gasolineCard', read: false, write: false }
                , { control: 'gasolineIdentifier', read: false, write: false }
                , { control: 'interbankClabe', read: false, write: false }
                , { control: 'subsidy', read: false, write: false }
                , { control: 'requisitionContractTypeId', read: true, write: false }
                , { control: 'laborSeniorityDate', read: false, write: false }
                , { control: 'employerRegisterId', read: true, write: true }
                , { control: 'salaryZoneId', read: false, write: false }
                , { control: 'familyMedicalUnitId', read: false, write: false }
                , { control: 'unionized', read: false, write: false }
                , { control: 'accountingSegmentId', read: false, write: false }
                , { control: 'individualAccount', read: false, write: false }
                , { control: 'pieceWorker', read: false, write: false }
                , { control: 'benefitCategoryId', read: false, write: false }
                , { control: 'alimony', read: false, write: false }
                , { control: 'hasInfonavit', read: true, write: true }
                , { control: 'schoolLevelId', read: false, write: false }
                , { control: 'educationLevelId', read: false, write: false }
                , { control: 'institute', read: false, write: false }
                , { control: 'documentReceivedId', read: false, write: false }
                , { control: 'studyPeriod', read: false, write: false }
                , { control: 'document', read: true, write: true }]
        },
        {
            profile: 'Juridico', activateSaveFormGeneralData: false, activateSaveFormPersonalData: false, activateSaveFormPaymentData: false, activateSaveFormBasicData: true, activateSaveFormStudy: false, activateSaveFormDocument: false, actions: [
                { control: 'firstName', read: true, write: false }
                , { control: 'lastName', read: true, write: false }
                , { control: 'secondLastName', read: true, write: false }
                , { control: 'birthDate', read: true, write: false }
                , { control: 'stateBirthId', read: true, write: false }
                , { control: 'gender', read: true, write: false }
                , { control: 'curp', read: true, write: false }
                , { control: 'rfc', read: true, write: false }
                , { control: 'imss', read: true, write: false }
                , { control: 'email', read: true, write: false }
                , { control: 'bossId', read: true, write: false }
                , { control: 'supervisorId', read: true, write: false }
                , { control: 'payrollOfficerId', read: true, write: false }
                , { control: 'workingDayId', read: true, write: false }
                , { control: 'maritalStatusId', read: true, write: false }
                , { control: 'personalNumber', read: true, write: false }
                , { control: 'street', read: true, write: false }
                , { control: 'interiorNumber', read: true, write: false }
                , { control: 'externalNumber', read: true, write: false }
                , { control: 'postalCode', read: true, write: false }
                , { control: 'suburb', read: true, write: false }
                , { control: 'stateId', read: true, write: false }
                , { control: 'townId', read: true, write: false }
                , { control: 'patrimonialRegimeId', read: true, write: false }
                , { control: 'dailySalary', read: true, write: false }
                , { control: 'integratedDailySalary', read: true, write: false }
                , { control: 'bankId', read: true, write: false }
                , { control: 'bankAccount', read: true, write: false }
                , { control: 'methodPaymentId', read: true, write: false }
                , { control: 'classification', read: false, write: false }
                , { control: 'typeSalaryId', read: false, write: false }
                , { control: 'pantryAccount', read: false, write: false }
                , { control: 'pantryCard', read: false, write: false }
                , { control: 'gasolineCard', read: false, write: false }
                , { control: 'gasolineIdentifier', read: false, write: false }
                , { control: 'interbankClabe', read: true, write: false }
                , { control: 'subsidy', read: false, write: false }
                , { control: 'requisitionContractTypeId', read: false, write: false }
                , { control: 'laborSeniorityDate', read: false, write: false }
                , { control: 'employerRegisterId', read: false, write: false }
                , { control: 'salaryZoneId', read: false, write: false }
                , { control: 'familyMedicalUnitId', read: false, write: false }
                , { control: 'unionized', read: false, write: false }
                , { control: 'accountingSegmentId', read: false, write: false }
                , { control: 'individualAccount', read: false, write: false }
                , { control: 'pieceWorker', read: false, write: false }
                , { control: 'benefitCategoryId', read: false, write: false }
                , { control: 'alimony', read: true, write: true }
                , { control: 'hasInfonavit', read: false, write: false }
                , { control: 'schoolLevelId', read: false, write: false }
                , { control: 'educationLevelId', read: false, write: false }
                , { control: 'institute', read: false, write: false }
                , { control: 'documentReceivedId', read: false, write: false }
                , { control: 'studyPeriod', read: false, write: false }
                , { control: 'document', read: false, write: false }]
        },
        {
            profile: 'DO', activateSaveFormGeneralData: false, activateSaveFormPersonalData: false, activateSaveFormPaymentData: false, activateSaveFormBasicData: false, activateSaveFormStudy: false, activateSaveFormDocument: false, actions: [
                { control: 'firstName', read: true, write: false }
                , { control: 'lastName', read: true, write: false }
                , { control: 'secondLastName', read: true, write: false }
                , { control: 'birthDate', read: true, write: false }
                , { control: 'stateBirthId', read: true, write: false }
                , { control: 'gender', read: true, write: false }
                , { control: 'curp', read: true, write: false }
                , { control: 'rfc', read: true, write: false }
                , { control: 'imss', read: true, write: false }
                , { control: 'email', read: true, write: false }
                , { control: 'bossId', read: true, write: false }
                , { control: 'supervisorId', read: true, write: false }
                , { control: 'payrollOfficerId', read: true, write: false }
                , { control: 'workingDayId', read: true, write: false }
                , { control: 'maritalStatusId', read: true, write: false }
                , { control: 'personalNumber', read: true, write: false }
                , { control: 'street', read: true, write: false }
                , { control: 'interiorNumber', read: true, write: false }
                , { control: 'externalNumber', read: true, write: false }
                , { control: 'postalCode', read: true, write: false }
                , { control: 'suburb', read: true, write: false }
                , { control: 'stateId', read: true, write: false }
                , { control: 'townId', read: true, write: false }
                , { control: 'patrimonialRegimeId', read: true, write: false }
                , { control: 'dailySalary', read: false, write: false }
                , { control: 'integratedDailySalary', read: false, write: false }
                , { control: 'bankId', read: true, write: false }
                , { control: 'bankAccount', read: true, write: false }
                , { control: 'methodPaymentId', read: true, write: false }
                , { control: 'classification', read: false, write: false }
                , { control: 'typeSalaryId', read: false, write: false }
                , { control: 'pantryAccount', read: false, write: false }
                , { control: 'pantryCard', read: false, write: false }
                , { control: 'gasolineCard', read: false, write: false }
                , { control: 'gasolineIdentifier', read: false, write: false }
                , { control: 'interbankClabe', read: true, write: false }
                , { control: 'subsidy', read: false, write: false }
                , { control: 'requisitionContractTypeId', read: false, write: false }
                , { control: 'laborSeniorityDate', read: false, write: false }
                , { control: 'employerRegisterId', read: false, write: false }
                , { control: 'salaryZoneId', read: false, write: false }
                , { control: 'familyMedicalUnitId', read: false, write: false }
                , { control: 'unionized', read: false, write: false }
                , { control: 'accountingSegmentId', read: false, write: false }
                , { control: 'individualAccount', read: false, write: false }
                , { control: 'pieceWorker', read: false, write: false }
                , { control: 'benefitCategoryId', read: false, write: false }
                , { control: 'alimony', read: false, write: false }
                , { control: 'hasInfonavit', read: false, write: false }
                , { control: 'schoolLevelId', read: true, write: false }
                , { control: 'educationLevelId', read: true, write: false }
                , { control: 'institute', read: true, write: false }
                , { control: 'documentReceivedId', read: true, write: false }
                , { control: 'studyPeriod', read: true, write: false }
                , { control: 'document', read: false, write: false }]
        },
        {
            profile: 'Datagos', activateSaveFormGeneralData: false, activateSaveFormPersonalData: false, activateSaveFormPaymentData: false, activateSaveFormBasicData: false, activateSaveFormStudy: false, activateSaveFormDocument: true, actions: [
                { control: 'firstName', read: true, write: false }
                , { control: 'lastName', read: true, write: false }
                , { control: 'secondLastName', read: true, write: false }
                , { control: 'birthDate', read: true, write: false }
                , { control: 'stateBirthId', read: true, write: false }
                , { control: 'gender', read: true, write: false }
                , { control: 'curp', read: true, write: false }
                , { control: 'rfc', read: true, write: false }
                , { control: 'imss', read: true, write: false }
                , { control: 'email', read: true, write: false }
                , { control: 'bossId', read: true, write: false }
                , { control: 'supervisorId', read: true, write: false }
                , { control: 'payrollOfficerId', read: true, write: false }
                , { control: 'workingDayId', read: true, write: false }
                , { control: 'maritalStatusId', read: false, write: false }
                , { control: 'personalNumber', read: true, write: false }
                , { control: 'street', read: true, write: false }
                , { control: 'interiorNumber', read: true, write: false }
                , { control: 'externalNumber', read: true, write: false }
                , { control: 'postalCode', read: true, write: false }
                , { control: 'suburb', read: true, write: false }
                , { control: 'stateId', read: true, write: false }
                , { control: 'townId', read: true, write: false }
                , { control: 'patrimonialRegimeId', read: false, write: false }
                , { control: 'dailySalary', read: false, write: false }
                , { control: 'integratedDailySalary', read: false, write: false }
                , { control: 'bankId', read: false, write: false }
                , { control: 'bankAccount', read: false, write: false }
                , { control: 'methodPaymentId', read: false, write: false }
                , { control: 'classification', read: false, write: false }
                , { control: 'typeSalaryId', read: false, write: false }
                , { control: 'pantryAccount', read: false, write: false }
                , { control: 'pantryCard', read: false, write: false }
                , { control: 'gasolineCard', read: false, write: false }
                , { control: 'gasolineIdentifier', read: false, write: false }
                , { control: 'interbankClabe', read: false, write: false }
                , { control: 'subsidy', read: false, write: false }
                , { control: 'requisitionContractTypeId', read: false, write: false }
                , { control: 'laborSeniorityDate', read: false, write: false }
                , { control: 'employerRegisterId', read: false, write: false }
                , { control: 'salaryZoneId', read: false, write: false }
                , { control: 'familyMedicalUnitId', read: false, write: false }
                , { control: 'unionized', read: false, write: false }
                , { control: 'accountingSegmentId', read: false, write: false }
                , { control: 'individualAccount', read: false, write: false }
                , { control: 'pieceWorker', read: false, write: false }
                , { control: 'benefitCategoryId', read: false, write: false }
                , { control: 'alimony', read: false, write: false }
                , { control: 'hasInfonavit', read: false, write: false }
                , { control: 'schoolLevelId', read: false, write: false }
                , { control: 'educationLevelId', read: false, write: false }
                , { control: 'institute', read: false, write: false }
                , { control: 'documentReceivedId', read: false, write: false }
                , { control: 'studyPeriod', read: false, write: false }
                , { control: 'document', read: true, write: true }]
        },
        {
            profile: 'Administracion', activateSaveFormGeneralData: false, activateSaveFormPersonalData: false, activateSaveFormPaymentData: false, activateSaveFormBasicData: false, activateSaveFormStudy: false, activateSaveFormDocument: false, actions: [
                { control: 'firstName', read: true, write: false }
                , { control: 'lastName', read: true, write: false }
                , { control: 'secondLastName', read: true, write: false }
                , { control: 'birthDate', read: true, write: false }
                , { control: 'stateBirthId', read: true, write: false }
                , { control: 'gender', read: true, write: false }
                , { control: 'curp', read: true, write: false }
                , { control: 'rfc', read: true, write: false }
                , { control: 'imss', read: true, write: false }
                , { control: 'email', read: true, write: false }
                , { control: 'bossId', read: true, write: false }
                , { control: 'supervisorId', read: true, write: false }
                , { control: 'payrollOfficerId', read: true, write: false }
                , { control: 'workingDayId', read: true, write: false }
                , { control: 'maritalStatusId', read: false, write: false }
                , { control: 'personalNumber', read: false, write: false }
                , { control: 'street', read: false, write: false }
                , { control: 'interiorNumber', read: false, write: false }
                , { control: 'externalNumber', read: false, write: false }
                , { control: 'postalCode', read: false, write: false }
                , { control: 'suburb', read: false, write: false }
                , { control: 'stateId', read: false, write: false }
                , { control: 'townId', read: false, write: false }
                , { control: 'country', read: false, write: false }
                , { control: 'patrimonialRegimeId', read: false, write: false }
                , { control: 'dailySalary', read: false, write: false }
                , { control: 'integratedDailySalary', read: false, write: false }
                , { control: 'bankId', read: true, write: false }
                , { control: 'bankAccount', read: true, write: false }
                , { control: 'methodPaymentId', read: true, write: false }
                , { control: 'classification', read: false, write: false }
                , { control: 'typeSalaryId', read: false, write: false }
                , { control: 'pantryAccount', read: true, write: false }
                , { control: 'pantryCard', read: true, write: false }
                , { control: 'gasolineCard', read: true, write: false }
                , { control: 'gasolineIdentifier', read: true, write: false }
                , { control: 'interbankClabe', read: true, write: false }
                , { control: 'subsidy', read: false, write: false }
                , { control: 'requisitionContractTypeId', read: false, write: false }
                , { control: 'laborSeniorityDate', read: false, write: false }
                , { control: 'employerRegisterId', read: false, write: false }
                , { control: 'salaryZoneId', read: false, write: false }
                , { control: 'familyMedicalUnitId', read: false, write: false }
                , { control: 'unionized', read: false, write: false }
                , { control: 'accountingSegmentId', read: false, write: false }
                , { control: 'individualAccount', read: false, write: false }
                , { control: 'pieceWorker', read: false, write: false }
                , { control: 'benefitCategoryId', read: false, write: false }
                , { control: 'alimony', read: false, write: false }
                , { control: 'hasInfonavit', read: false, write: false }
                , { control: 'schoolLevelId', read: false, write: false }
                , { control: 'educationLevelId', read: false, write: false }
                , { control: 'institute', read: false, write: false }
                , { control: 'documentReceivedId', read: false, write: false }
                , { control: 'studyPeriod', read: false, write: false }
                , { control: 'document', read: false, write: false }]
        },
        {
            profile: 'Sistemas', activateSaveFormGeneralData: false, activateSaveFormPersonalData: false, activateSaveFormPaymentData: false, activateSaveFormBasicData: false, activateSaveFormStudy: false, activateSaveFormDocument: true, actions: [
                { control: 'firstName', read: true, write: false }
                , { control: 'lastName', read: true, write: false }
                , { control: 'secondLastName', read: true, write: false }
                , { control: 'birthDate', read: true, write: false }
                , { control: 'stateBirthId', read: true, write: false }
                , { control: 'gender', read: true, write: false }
                , { control: 'curp', read: true, write: false }
                , { control: 'rfc', read: true, write: false }
                , { control: 'imss', read: true, write: false }
                , { control: 'email', read: true, write: false }
                , { control: 'bossId', read: true, write: false }
                , { control: 'supervisorId', read: true, write: false }
                , { control: 'payrollOfficerId', read: true, write: false }
                , { control: 'workingDayId', read: true, write: false }
                , { control: 'maritalStatusId', read: true, write: false }
                , { control: 'personalNumber', read: true, write: false }
                , { control: 'street', read: true, write: false }
                , { control: 'interiorNumber', read: true, write: false }
                , { control: 'externalNumber', read: true, write: false }
                , { control: 'postalCode', read: true, write: false }
                , { control: 'suburb', read: true, write: false }
                , { control: 'stateId', read: true, write: false }
                , { control: 'townId', read: true, write: false }
                , { control: 'country', read: true, write: false }
                , { control: 'patrimonialRegimeId', read: true, write: false }
                , { control: 'dailySalary', read: false, write: false }
                , { control: 'integratedDailySalary', read: false, write: false }
                , { control: 'bankId', read: true, write: false }
                , { control: 'bankAccount', read: true, write: false }
                , { control: 'methodPaymentId', read: true, write: false }
                , { control: 'classification', read: true, write: false }
                , { control: 'typeSalaryId', read: true, write: false }
                , { control: 'pantryAccount', read: true, write: false }
                , { control: 'pantryCard', read: true, write: false }
                , { control: 'gasolineCard', read: true, write: false }
                , { control: 'gasolineIdentifier', read: true, write: false }
                , { control: 'interbankClabe', read: true, write: false }
                , { control: 'subsidy', read: true, write: false }
                , { control: 'requisitionContractTypeId', read: true, write: false }
                , { control: 'laborSeniorityDate', read: true, write: false }
                , { control: 'employerRegisterId', read: true, write: false }
                , { control: 'salaryZoneId', read: true, write: false }
                , { control: 'familyMedicalUnitId', read: true, write: false }
                , { control: 'unionized', read: true, write: false }
                , { control: 'accountingSegmentId', read: true, write: false }
                , { control: 'individualAccount', read: true, write: false }
                , { control: 'pieceWorker', read: true, write: false }
                , { control: 'benefitCategoryId', read: true, write: false }
                , { control: 'alimony', read: true, write: false }
                , { control: 'hasInfonavit', read: true, write: false }
                , { control: 'schoolLevelId', read: true, write: false }
                , { control: 'educationLevelId', read: true, write: false }
                , { control: 'institute', read: true, write: false }
                , { control: 'documentReceivedId', read: true, write: false }
                , { control: 'studyPeriod', read: true, write: false }
                , { control: 'document', read: true, write: true }]
        },
        {
            profile: 'Logistica', activateSaveFormGeneralData: false, activateSaveFormPersonalData: false, activateSaveFormPaymentData: false, activateSaveFormBasicData: false, activateSaveFormStudy: false, activateSaveFormDocument: false, actions: [
                { control: 'firstName', read: true, write: false }
                , { control: 'lastName', read: true, write: false }
                , { control: 'secondLastName', read: true, write: false }
                , { control: 'birthDate', read: false, write: false }
                , { control: 'hiringDate', read: false, write: false }
                , { control: 'stateBirthId', read: false, write: false }
                , { control: 'gender', read: false, write: false }
                , { control: 'curp', read: false, write: false }
                , { control: 'rfc', read: false, write: false }
                , { control: 'imss', read: false, write: false }
                , { control: 'email', read: false, write: false }
                , { control: 'bossId', read: true, write: false }
                , { control: 'supervisorId', read: true, write: false }
                , { control: 'payrollOfficerId', read: false, write: false }
                , { control: 'job', read: false, write: false }
                , { control: 'positionNo', read: false, write: false }
                , { control: 'companyName', read: true, write: false }
                , { control: 'projectName', read: false, write: false }
                , { control: 'planName', read: false, write: false }
                , { control: 'zoneName', read: false, write: false }
                , { control: 'townName', read: false, write: false }
                , { control: 'businessPhone', read: false, write: false }
                , { control: 'workingDayId', read: false, write: false }
                , { control: 'maritalStatusId', read: false, write: false }
                , { control: 'personalNumber', read: true, write: false }
                , { control: 'street', read: true, write: false }
                , { control: 'interiorNumber', read: true, write: false }
                , { control: 'externalNumber', read: true, write: false }
                , { control: 'postalCode', read: true, write: false }
                , { control: 'suburb', read: true, write: false }
                , { control: 'stateId', read: true, write: false }
                , { control: 'townId', read: true, write: false }
                , { control: 'country', read: true, write: false }
                , { control: 'patrimonialRegimeId', read: false, write: false }
                , { control: 'dailySalary', read: false, write: false }
                , { control: 'integratedDailySalary', read: false, write: false }
                , { control: 'bankId', read: false, write: false }
                , { control: 'bankAccount', read: false, write: false }
                , { control: 'methodPaymentId', read: false, write: false }
                , { control: 'classification', read: false, write: false }
                , { control: 'typeSalaryId', read: false, write: false }
                , { control: 'pantryAccount', read: false, write: false }
                , { control: 'pantryCard', read: false, write: false }
                , { control: 'gasolineCard', read: false, write: false }
                , { control: 'gasolineIdentifier', read: false, write: false }
                , { control: 'interbankClabe', read: false, write: false }
                , { control: 'subsidy', read: false, write: false }
                , { control: 'requisitionContractTypeId', read: false, write: false }
                , { control: 'laborSeniorityDate', read: false, write: false }
                , { control: 'employerRegisterId', read: false, write: false }
                , { control: 'salaryZoneId', read: false, write: false }
                , { control: 'familyMedicalUnitId', read: false, write: false }
                , { control: 'unionized', read: false, write: false }
                , { control: 'accountingSegmentId', read: false, write: false }
                , { control: 'individualAccount', read: false, write: false }
                , { control: 'pieceWorker', read: false, write: false }
                , { control: 'benefitCategoryId', read: false, write: false }
                , { control: 'alimony', read: false, write: false }
                , { control: 'hasInfonavit', read: false, write: false }
                , { control: 'schoolLevelId', read: false, write: false }
                , { control: 'educationLevelId', read: false, write: false }
                , { control: 'institute', read: false, write: false }
                , { control: 'documentReceivedId', read: false, write: false }
                , { control: 'studyPeriod', read: false, write: false }
                , { control: 'document', read: false, write: false }]
        },
        {
            profile: 'SMC', activateSaveFormGeneralData: false, activateSaveFormPersonalData: false, activateSaveFormPaymentData: false, activateSaveFormBasicData: false, activateSaveFormStudy: false, activateSaveFormDocument: false, actions: [
                { control: 'firstName', read: true, write: false }
                , { control: 'lastName', read: true, write: false }
                , { control: 'secondLastName', read: true, write: false }
                , { control: 'birthDate', read: false, write: false }
                , { control: 'trackingStatus', read: false, write: false }
                , { control: 'hiringDate', read: false, write: false }
                , { control: 'dismissalDate', read: false, write: false }
                , { control: 'stateBirthId', read: false, write: false }
                , { control: 'gender', read: false, write: false }
                , { control: 'curp', read: false, write: false }
                , { control: 'rfc', read: false, write: false }
                , { control: 'imss', read: false, write: false }
                , { control: 'email', read: false, write: false }
                , { control: 'bossId', read: false, write: false }
                , { control: 'supervisorId', read: false, write: false }
                , { control: 'payrollOfficerId', read: false, write: false }
                , { control: 'job', read: false, write: false }
                , { control: 'positionNo', read: false, write: false }
                , { control: 'companyName', read: true, write: false }
                , { control: 'projectName', read: false, write: false }
                , { control: 'planName', read: false, write: false }
                , { control: 'customer', read: true, write: false }
                , { control: 'zoneName', read: false, write: false }
                , { control: 'townName', read: false, write: false }
                , { control: 'businessPhone', read: false, write: false }
                , { control: 'workingDayId', read: false, write: false }
                , { control: 'maritalStatusId', read: false, write: false }
                , { control: 'personalNumber', read: false, write: false }
                , { control: 'street', read: false, write: false }
                , { control: 'interiorNumber', read: false, write: false }
                , { control: 'externalNumber', read: false, write: false }
                , { control: 'postalCode', read: false, write: false }
                , { control: 'suburb', read: false, write: false }
                , { control: 'stateId', read: false, write: false }
                , { control: 'townId', read: false, write: false }
                , { control: 'country', read: false, write: false }
                , { control: 'patrimonialRegimeId', read: false, write: false }
                , { control: 'dailySalary', read: false, write: false }
                , { control: 'integratedDailySalary', read: false, write: false }
                , { control: 'bankId', read: false, write: false }
                , { control: 'bankAccount', read: false, write: false }
                , { control: 'methodPaymentId', read: false, write: false }
                , { control: 'classification', read: false, write: false }
                , { control: 'typeSalaryId', read: false, write: false }
                , { control: 'pantryAccount', read: false, write: false }
                , { control: 'pantryCard', read: false, write: false }
                , { control: 'gasolineCard', read: false, write: false }
                , { control: 'gasolineIdentifier', read: false, write: false }
                , { control: 'interbankClabe', read: false, write: false }
                , { control: 'subsidy', read: false, write: false }
                , { control: 'requisitionContractTypeId', read: false, write: false }
                , { control: 'laborSeniorityDate', read: false, write: false }
                , { control: 'employerRegisterId', read: false, write: false }
                , { control: 'salaryZoneId', read: false, write: false }
                , { control: 'familyMedicalUnitId', read: false, write: false }
                , { control: 'unionized', read: false, write: false }
                , { control: 'accountingSegmentId', read: false, write: false }
                , { control: 'individualAccount', read: false, write: false }
                , { control: 'pieceWorker', read: false, write: false }
                , { control: 'benefitCategoryId', read: false, write: false }
                , { control: 'alimony', read: false, write: false }
                , { control: 'hasInfonavit', read: false, write: false }
                , { control: 'schoolLevelId', read: false, write: false }
                , { control: 'educationLevelId', read: false, write: false }
                , { control: 'institute', read: false, write: false }
                , { control: 'documentReceivedId', read: false, write: false }
                , { control: 'studyPeriod', read: false, write: false }
                , { control: 'document', read: false, write: false }]
        }];
    public readFormControlEmployeeModule(profile: string, control: string): boolean {
        let p = this.employeeModuleProfiles.filter(x => x.profile == profile)[0];
        let a = p.actions.filter(c => c.control == control)[0];
        return a == null ? true : a.read;
    }
    public writeFormControlEmployeeModule(profile: string, control: string): boolean {
        let p = this.employeeModuleProfiles.filter(x => x.profile == profile)[0];
        let a = p.actions.filter(c => c.control == control)[0];
        return a == null ? false : a.write;
    }
    public activateSaveForm(profile: string): IDtoEmployeeModuleProfile {
        return this.employeeModuleProfiles.filter(x => x.profile == profile)[0];
    }
}

export interface IDtoEmployeeModuleProfile {
    profile: string;
    activateSaveFormGeneralData: boolean;
    activateSaveFormPersonalData: boolean;
    activateSaveFormPaymentData: boolean;
    activateSaveFormBasicData: boolean;
    activateSaveFormStudy: boolean;
    activateSaveFormDocument: boolean;
    actions: IDtoActions[];
}
export interface IDtoActions {
    control: string;
    write: boolean;
    read: boolean;
}